<template>
  <div>
    <div
      v-if="hasMissingSyncStart"
      class="global-ribbon-warning"
      @click="openMissingSyncInfo"
    >
      ⚠️ Vânzarea NU este pornită pentru locațiile:
      <strong>{{ missingSyncLocations.join(', ') }}</strong>
      – Click pentru detalii.
    </div>
    <div class="row settings-tabs full-height-tabs">
      <div class="col-lg-12 col-md-12">
        <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row management-tabs full-height-tabs items-align-management-tabs text-align-management-tabs"
            :value="selectedTabIndex"
            @tab-change="handleTabChange"
          >
          <v-tab v-if="userHasRight('can_access_gestiune')" name="reteta" ref="reteta" :title="$t('gestiune.reteta')" class="text-left">
            <keep-alive>
              <nomenclator-tabs
                v-if="shouldLoadTab('reteta')"
                :grouped-locations="groupedLocations"
                :gestiuneOptions="gestiuneOptions"
                :key="'reteta-' + groupedLocationsKey">
              </nomenclator-tabs>
            </keep-alive>
          </v-tab>
          <!-- <v-tab v-if="userHasRight('can_access_dashboard')" name="dashboard" ref="dashboard" :title="$t('gestiune.dashboard')" class="text-left">
            <keep-alive>
              <management-dashboard
                v-if="shouldLoadTab('dashboard')"
                :key="'dashboard-' + groupedLocationsKey">
              </management-dashboard>
            </keep-alive>
          </v-tab> -->
          <v-tab v-if="userHasRight('can_generate_nir')" name="entries" ref="entries" :title="$t('gestiune.entries')" class="text-left">
            <keep-alive>
              <management-entries-tabs
                v-if="shouldLoadTab('entries')"
                :grouped-locations="groupedLocations"
                :key="'entries-' + groupedLocationsKey">
              </management-entries-tabs>
            </keep-alive>
          </v-tab>
          <v-tab v-if="userHasRight('can_access_gestiune')" name="outputs" ref="outputs" :title="$t('gestiune.outputs')" class="text-left" >
            <keep-alive>
              <management-outputs-tabs
                v-if="shouldLoadTab('outputs')"
                :grouped-locations="groupedLocations"
                :key="'outputs-' + groupedLocationsKey">
              </management-outputs-tabs>
            </keep-alive>
          </v-tab>
          <v-tab v-if="userHasRight('can_access_gestiune')" name="stocks" ref="stocks" :title="$t('gestiune.stocks')" class="text-left">
            <keep-alive>
              <management-stocks-tabs
                v-if="shouldLoadTab('stocks')"
                :grouped-locations="groupedLocations"
                :gestiuneOptions="gestiuneOptions"
                :key="'stocks-' + groupedLocationsKey">
              </management-stocks-tabs>
            </keep-alive>
          </v-tab>
          <!-- <v-tab v-if="userHasRight('can_access_gestiune')" name="production" ref="production" :title="$t('gestiune.production')" class="text-left">
            <keep-alive>
              <management-production
                v-if="shouldLoadTab('production')"
                :grouped-locations="groupedLocations"
                :gestiuneOptions="gestiuneOptions"
                :key="'production-' + groupedLocationsKey">
              </management-production>
            </keep-alive>
          </v-tab> -->
          <v-tab v-if="userHasRight('can_access_supplier_orders')" name="ordersSuppliers" ref="ordersSuppliers" :title="$t('gestiune.ordersSuppliers')" class="text-left">
            <keep-alive>
              <management-suppliers-tabs
                v-if="shouldLoadTab('ordersSuppliers')"
                :grouped-locations="groupedLocations"
                :gestiuneOptions="gestiuneOptions"
                :key="'ordersSuppliers-' + groupedLocationsKey">
              </management-suppliers-tabs>
            </keep-alive>
          </v-tab>
          <v-tab v-if="userHasRight('can_access_reports')" name="reports" ref="reports" :title="$t('gestiune.reports')" class="text-left">
            <keep-alive>
              <management-reports
                v-if="shouldLoadTab('reports')"
                :grouped-locations="groupedLocations"
                :gestiuneOptions="gestiuneOptions"
                :key="'reports-' + groupedLocationsKey">
              </management-reports>
            </keep-alive>
          </v-tab>
          <v-tab name="exports" ref="exports" :title="$t('gestiune.exports')" class="text-left">
            <keep-alive>
              <management-exports
                v-if="shouldLoadTab('exports')"
                :locations="locations"
                :gestiuneOptions="gestiuneOptions"
                :grouped-locations="groupedLocations"
                :key="'exports-' + groupedLocationsKey"
                @fetchLocation="fetchLocation"
              ></management-exports>
            </keep-alive>
          </v-tab>
          <v-tab v-if="userHasRight('can_access_settings')" name="settings" ref="settings" :title="$t('gestiune.settings')" class="text-left">
            <keep-alive>
              <management-settings
                v-if="shouldLoadTab('settings')"
                :locations="locations"
                :grouped-locations="groupedLocations"
                :key="'settings-' + groupedLocationsKey"
                @fetchLocation="fetchLocation"
              ></management-settings>
            </keep-alive>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
import ManagementDashboard from '../Management/Dashboard/ManagementDashboard.vue'
import NomenclatorTabs from '../Management/Nomenclator/NomenclatorTabs.vue'
import ManagementOrdersSuppliers from '../Management/Suppliers/ManagementOrdersSuppliers.vue'
import ManagementSuppliersTabs from '../Management/Suppliers/ManagementSuppliersTabs.vue'
import ManagementCasaRegister from '../Management/Casa/ManagementCasaRegister.vue'
import ManagementSettings from '../Management/ManagementSettings.vue'
import ManagementReports from '../Management/ManagementReports.vue'
import ManagementOutputsTabs from '../Management/ManagementOutputsTabs.vue'
import ManagementEntriesTabs from '../Management/ManagementEntriesTabs.vue'
import ManagementStocksTabs from '../Management/ManagementStocksTabs.vue'
import ManagementProduction from '../Management/ManagementProduction.vue'
import ManagementExports from '../Management/ManagementExports.vue'
import swal from 'sweetalert2'

export default {
  components: {
    ManagementOutputsTabs,
    ManagementEntriesTabs,
    ManagementStocksTabs,
    ManagementSuppliersTabs,
    ManagementDashboard,
    NomenclatorTabs,
    ManagementOrdersSuppliers,
    ManagementCasaRegister,
    ManagementSettings,
    ManagementReports,
    ManagementProduction,
    ManagementExports
  },
  data () {
    return {
      selectedTabIndex: 0,
      groupedLocationsKey: 0,
      activeTabName: '', // tab-ul curent activ
      loadedTabs: new Set(), // tab-urile care au fost încărcate
      // Eliminați variabilele boolean inutile
      locations: [],
      gestiuneOptions: [],
      hasMissingSyncStart: false,
      missingSyncLocations: []
    }
  },
  mounted () {
    this.companyID = this.$session.get('selectedCompany')

    this.switchTab()
    this.fetchLocation()
    this.fetchGestiuni()
  },
  watch: {
    groupedLocations (newVal) {
      this.groupedLocationsKey++
    }
  },
  computed: {
    groupedLocations () {
      const groups = {}

      this.locations.forEach(location => {
        const vat = location.inv_fiscal_code || 'Fără cod fiscal'
        if (!groups[vat]) {
          groups[vat] = []
        }
        groups[vat].push(location)
      })

      const result = Object.entries(groups).map(([vat, locations]) => ({
        vat,
        locations
      }))

      return result
    }
  },
  methods: {
    // Metodă pentru a determina dacă un tab trebuie încărcat
    shouldLoadTab(tabName) {
      // Încarcă tab-ul doar dacă este activ sau a fost încărcat anterior
      return this.activeTabName === tabName || this.loadedTabs.has(tabName)
    },

    getVisibleTabsIndexMap () {
      const tabs = [
        { name: 'dashboard', right: 'can_access_dashboard' },
        { name: 'outputs', right: 'can_access_gestiune' },
        { name: 'entries', right: 'can_access_gestiune' },
        { name: 'stocks', right: 'can_access_gestiune' },
        { name: 'production', right: 'can_access_gestiune' },
        { name: 'reteta', right: 'can_access_gestiune' },
        { name: 'ordersSuppliers', right: 'can_access_supplier_orders' },
        { name: 'reports', right: 'can_access_reports' },
        { name: 'settings', right: 'can_access_settings' }
      ]

      const indexMap = {}
      let currentIndex = 0

      for (const tab of tabs) {
        if (this.userHasRight(tab.right)) {
          indexMap[tab.name] = currentIndex
          currentIndex++
        }
      }

      return indexMap
    },

    switchTab () {
      const query = this.$route.query
      const tabIndexMap = this.getVisibleTabsIndexMap()

      if (query.tab) {
        const tabName = query.tab
        this.selectedTabIndex = tabIndexMap[tabName]
        this.activeTabName = tabName
        this.loadedTabs.add(tabName)

        // Dacă tab-ul este 'reteta' și există vatNumber în query
        if (tabName === 'reteta' && query.vatNumber) {
          this.selectedVatNumber = query.vatNumber
          console.log('VAT Number set from query for reteta:', this.selectedVatNumber)
        }
      } else {
        // Dacă nu există query param, setează primul tab disponibil
        const firstAvailableTab = this.getFirstAvailableTab()
        if (firstAvailableTab) {
          this.activeTabName = firstAvailableTab
          this.loadedTabs.add(firstAvailableTab)
        }
      }
    },

    getFirstAvailableTab() {
      const tabs = [
        { name: 'dashboard', right: 'can_access_dashboard' },
        { name: 'outputs', right: 'can_access_gestiune' },
        { name: 'entries', right: 'can_access_gestiune' },
        { name: 'stocks', right: 'can_access_gestiune' },
        { name: 'production', right: 'can_access_gestiune' },
        { name: 'reteta', right: 'can_access_gestiune' },
        { name: 'ordersSuppliers', right: 'can_access_supplier_orders' },
        { name: 'reports', right: 'can_access_reports' },
        { name: 'settings', right: 'can_access_settings' }
      ]

      for (const tab of tabs) {
        if (this.userHasRight(tab.right)) {
          return tab.name
        }
      }
      return null
    },

    handleTabChange(index, tab) {
      let tabName = null
      if (tab && tab.$attrs) {
        tabName = tab.$attrs.name
        this.activeTabName = tabName
        // Marchează tab-ul ca încărcat când utilizatorul navighează la el
        this.loadedTabs.add(tabName)
      }

      // Construim query-ul pentru router
      const newQuery = { tab: tabName }

      // Dacă tab-ul este reteta și avem vatNumber selectat, îl adăugăm
      if (tabName === 'reteta' && this.selectedVatNumber) {
        newQuery.vatNumber = this.selectedVatNumber
      }

      // Navigăm la ruta cu query actualizat
      this.$router.push({ path: this.$route.path, query: newQuery })
    },

    fetchLocation () {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      }

      this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
        if (!response || response.status !== true || !response.data || !response.data.locations) {
          swal({
            title: 'Eroare!',
            text: response.message || 'Eroare la preluarea locațiilor.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
          return
        }

        this.locations = response.data.locations

        const missing = this.locations.filter(loc => {
          console.log(loc)
          if (!loc.gestiune_id_default) {
            return false
          }

          return (
            !loc.gestiune_start_sync_order ||
            loc.gestiune_start_sync_order === "0000-00-00 00:00:00"
          )
        })

        this.missingSyncLocations = missing.map(l => l.name) // nume locații
        this.hasMissingSyncStart = missing.length > 0
      })
    },
    openMissingSyncInfo () {
      swal({
        title: "Acțiune necesară!",
        html: `
          <p>Trebuie să mergi în <strong>Setări → Tab-ul Operatiuni</strong>.</p>
          <p>Din dropdown, selectează locația dorită și setează o <strong>dată de început a sincronizării</strong>.</p>
          <p>Doar după această configurare vânzarea va fi activă pentru locație.</p>
          <p style="margin-top: 15px; font-weight: bold; color: #d32f2f;">
            După ce completezi aceste câmpuri, <br>
            <span style="text-decoration: underline;">apasă butonul „PORNEȘTE VÂNZĂRILE”.</span>
          </p>
        `,
        icon: "info",
        confirmButtonText: "Am înțeles",
        timer: 10000,
        buttons: true
      })
    },
    async fetchGestiuni () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
        if (!response.ok) throw new Error('Failed to fetch gestiuni')

        const data = await response.json()
        if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
          this.gestiuneOptions = data.gestiuni.map((gest) => ({
            id: gest._id,
            name: `${gest.name} (${gest.cod_gestiune})`,
            externalLocationId: gest.externalLocationId || '',
            categorie: gest.categorie || ''
          }))
        } else {
          this.$message.error('Nu s-a primit un array valid de la server.')
        }
      } catch (error) {
        this.$message.error(`Request failed: ${error.message}`)
        console.error('Error fetching management data:', error)
      }
    }
  }
}
</script>

<style scoped>
.global-ribbon-warning {
  width: 100%;
  max-width: 98%;
  margin: 10px auto 0 auto;

  position: sticky;
  top: 10px;
  z-index: 99999;

  /* mov finuț cu opacitate */
  background: rgba(103, 75, 210, 0.25); /* #674BD2 cu 25% opacity */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  padding: 14px 24px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;

  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.25);

  color: #25396F;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);

  cursor: pointer;

  animation: ribbonFadeIn 0.35s ease-out;
}
.global-ribbon-warning strong {
  font-weight: 700;
  color: #25396F;
}

@keyframes ribbonFadeIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.global-ribbon-warning:hover {
  background: rgba(103, 75, 210, 0.35); /* puțin mai intens la hover */
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementSidebar.vue